import { useCallback, useState } from 'react';
import { clearedBarFilters, parsePayableFilters, type PayableFilters } from './payableFilters';

/**
 * The bill list's filter state. It STARTS from the URL's query string, read once when the page
 * opens, so a report figure can link to `/accounts?tab=payable&supplier=..&dueFrom=..` and land on
 * exactly those bills. After that the page's own controls own it.
 */
export function usePayableFilters() {
  const [filters, setFilters] = useState<PayableFilters>(() => parsePayableFilters(window.location.search));

  const update = useCallback((patch: Partial<PayableFilters>) => {
    setFilters((prev) => ({ ...prev, ...patch }));
  }, []);
  const clear = useCallback(() => {
    setFilters((prev) => clearedBarFilters(prev));
  }, []);

  return { filters, update, clear };
}
